import { createBrowserHistory } from "history";
import * as localforage from "localforage"
import { legacy_createStore as createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from '@redux-devtools/extension';
import createSagaMiddleware from "redux-saga";
import { createLogger } from "redux-logger";
import { PersistConfig, persistReducer, persistStore } from "redux-persist"; 

import rootReducer from "./rootReducer";
import { rootSaga } from "./rootSaga";
import {Reducer} from "react";

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware();

const persistConfig: PersistConfig<any, any, any, any> = {
	key: "root",
	version: 1,
	storage: localforage,
	blacklist: [''],
};

const logger = (createLogger as any)();
const history = createBrowserHistory();

const dev = process.env.NODE_ENV === "development";

let middleware = dev 
					? composeWithDevTools(applyMiddleware(sagaMiddleware)) 
					: applyMiddleware(sagaMiddleware);

const persistedReducer = persistReducer(persistConfig, rootReducer(history) as Reducer<any, any>);

const ConfigStore =  () => {
	const store = createStore(persistedReducer, middleware);
	const persistor = persistStore(store);
	return {
		store, persistor, runSaga: sagaMiddleware.run(rootSaga)
	};
};

export default ConfigStore;

export { history };
